import * as React from 'react'
import Tile from './tile'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type Accent = 'green' | 'blue' | 'orange' | 'purple'

const accentMap: Record<Accent, { from: string; to: string; text: string; border: string }>= {
  green: { from: 'from-green-50', to: 'to-emerald-50', text: 'text-green-700', border: 'border-green-200' },
  blue: { from: 'from-blue-50', to: 'to-sky-50', text: 'text-blue-700', border: 'border-blue-200' },
  orange: { from: 'from-amber-50', to: 'to-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
  purple: { from: 'from-violet-50', to: 'to-purple-50', text: 'text-violet-700', border: 'border-violet-200' },
}

export default function HighlightCard({
  accent = 'green',
  title,
  description,
  icon,
  children,
  action,
  className,
}: {
  accent?: Accent
  title?: React.ReactNode
  description?: React.ReactNode
  icon?: React.ReactNode
  children?: React.ReactNode
  action?: React.ReactNode
  className?: string
}) {
  const accentStyles = accentMap[accent]
  return (
    // Use Tile's outer background – highlight-specific accents map to tile variants
    <Tile className={cn(className)} variant={accent === 'green' ? 'success' : accent === 'orange' ? 'warning' : accent === 'blue' ? 'info' : 'accent'}>
      <div>
        <div className="flex items-start justify-between">
          <div>
            <div className="flex items-center gap-3">
              {/* icon intentionally not rendered to keep tile clean; title will carry accent underline */}
        {title && <div className={cn('tile-title text-lg md:text-xl font-extrabold', accentStyles.text)}>{title}</div>}
        {/* NOTE: The title sizing above is intentionally set to text-lg/md:text-xl to keep
          the three highlight tiles compact. Change these classes if you want larger
          or smaller highlight titles site-wide. */}
            </div>
            {description && <div className="tile-subtitle mt-1">{description}</div>}
          </div>
          {action ? <div>{action}</div> : null}
        </div>

        <div className="mt-4">
          {children}
        </div>
      </div>
    </Tile>
  )
}
